import { getAxiosWithConfig } from '../Http/HttpService';
import { ObjectParams, ObjectsParams, ObjectVacationsParams } from '../../types/ParamsTypes';
import { AxiosResponse } from 'axios';
import {
  ObjectResponse,
  ObjectSeasonPrice,
  ServiceFieldType,
  SingleObject,
} from '../../types/ObjectTypes';
import { BookingParams } from '../../types/BookingTypes';
import { ExtendedDetailsRoute } from '../../types/RoutesTypes';
import { ObjectVacationsResponse } from '../../types/ObjectVacationTypes';
import { getArrayObjectsRouteParam } from '../Objects/ObjectsService';

export const fetchObject = async (
  objectParams: ObjectParams,
): Promise<AxiosResponse<ObjectResponse>> => {
  try {
    const instance = getAxiosWithConfig();

    return instance.post('plugin', {
      plugin: 'booking',
      data: {
        module: 'objectData',
        params: objectParams,
      },
    });
  } catch (e) {
    throw new Error(e);
  }
};

export const fetchObjectVacations = async (
  objectVacationParams: ObjectVacationsParams,
): Promise<AxiosResponse<ObjectVacationsResponse>> => {
  try {
    const instance = getAxiosWithConfig();

    return instance.post('plugin', {
      plugin: 'booking',
      data: {
        module: 'objectVacations',
        params: objectVacationParams,
      },
    });
  } catch (e) {
    throw new Error(e);
  }
};

export const isQualifiedToFetchWithExtendedParams = (params: {
  id?: string;
  fromDate?: string;
  toDate?: string;
}): boolean => {
  const { id, toDate, fromDate } = params;
  return !!id && !!toDate && !!fromDate;
};

export const getExtendedObjectRoute = (
  object: SingleObject,
  objectsParams: ObjectsParams | ObjectParams,
): string => {
  const agesOfChildren = objectsParams.agesOfChildren.length
    ? objectsParams.agesOfChildren.join(',')
    : 'no_ages';
  return `/objects/${object.baseData.uniqueId}/${objectsParams.numberOfAdults}/${objectsParams.numberOfChildren}/${agesOfChildren}/${objectsParams?.numberOfPets}/${objectsParams?.fromDate}/${objectsParams?.toDate}`;
};

export const getSimpleObjectRoute = (object: SingleObject, objectsParams: ObjectsParams | ObjectParams): string => {
  const agesOfChildren = objectsParams.agesOfChildren.length
    ? objectsParams.agesOfChildren.join(',')
    : 'no_ages';
  return `/objects/${object.baseData.uniqueId}/${objectsParams.numberOfAdults}/${objectsParams.numberOfChildren}/${agesOfChildren}/${objectsParams?.numberOfPets}`;
};

export const getObjectParamsFromRouteParams = (routeParams: ExtendedDetailsRoute): ObjectParams => {
  return Object.assign(
    {} as any,
    {
      Object: routeParams.id,
    },
    {
      numberOfAdults:
        typeof routeParams.numberOfAdults !== 'undefined'
          ? parseInt(routeParams.numberOfAdults)
          : 2,
    },
    {
      numberOfChildren:
        typeof routeParams.numberOfChildren !== 'undefined'
          ? parseInt(routeParams.numberOfChildren)
          : 0,
    },
    {
      agesOfChildren: getArrayObjectsRouteParam('ages', routeParams?.agesOfChildren),
    },
    { numberOfPets: routeParams.numberOfPets ? +routeParams.numberOfPets : 0 },
    routeParams.fromDate && { fromDate: routeParams.fromDate },
    routeParams.toDate && { toDate: routeParams.toDate },
  );
};

export const getObjectParamsFromBookingParams = (bookingParams: BookingParams): ObjectParams => {
  return {
    Object: bookingParams.Object,
    fromDate: bookingParams.fromDate,
    toDate: bookingParams.toDate,
    numberOfAdults: bookingParams.numberOfAdults,
    numberOfChildren: bookingParams.numberOfChildren,
    agesOfChildren: bookingParams.agesOfChildren,
    numberOfPets: bookingParams.numberOfPets,
    services: bookingParams.services.filter(service => service.quantity > 0),
  };
};

export const getStringByServiceFieldType = (serviceFieldType: ServiceFieldType): string => {
  let serviceFieldTypeString = '';
  switch (serviceFieldType) {
    case ServiceFieldType.PER_DAY_DURATION:
      serviceFieldTypeString = 'Pro Tag (ganzer Zeitraum)';
      break;
    case ServiceFieldType.PER_DAY:
      serviceFieldTypeString = 'Pro Tag';
      break;
    case ServiceFieldType.UNIT:
      serviceFieldTypeString = 'Einheit';
      break;
    case ServiceFieldType.FLAT_RATE:
      serviceFieldTypeString = 'Pauschale';
      break;
    case ServiceFieldType.FLAT_RATE_DURATION_ADULT:
      serviceFieldTypeString = 'Preis pro Tag pro Erw.';
      break;
    case ServiceFieldType.FLAT_RATE_PET:
      serviceFieldTypeString = 'Pauschale pro Haustier';
      break;
  }

  return serviceFieldTypeString;
};

export const getDefaultObjectParams = (params: {
  Object: string;
  fromDate: string;
  toDate: string;
}): ObjectParams => {
  return {
    Object: params.Object,
    fromDate: params.fromDate,
    toDate: params.toDate,
    numberOfAdults: 2,
    numberOfChildren: 0,
    agesOfChildren: [],
    numberOfPets: 0,
  };
};
